<div class="our__tools">
  <div class="tools__header flex flex-col items-center gap-4">
    <h2 translate="What we Have"></h2>
    <h3 translate="Our Tools"></h3>
    <p class="text-center" translate="We provide you 4+ free online tools, more is coming"></p>
  </div>

  <div class="tools__content grid md:grid-cols-4 grid-cols-2 gap-4 mt-6">
    <a class="md:col-span-2 col-span-1 tool__card" [routerLink]="['/', i18nService.language, 'url-shortener']">
      <div inlineSVG="our-tools/link.svg"></div>
      <span class="tool__name" translate="URL Shortener"></span>
    </a>
    <a class="md:col-span-2 col-span-1 tool__card" [routerLink]="['/', i18nService.language, 'qr-code-generator']">
      <div inlineSVG="our-tools/scan-barcode.svg"></div>
      <span class="tool__name" translate="QR Code Generator"></span>
    </a>
    <a class="tool__card" [routerLink]="['/', i18nService.language, 'seo-tags-extractor']">
      <div inlineSVG="our-tools/ranking.svg"></div>
      <span class="tool__name" translate="SEO Extractor"></span>
    </a>

    <a class="md:col-span-2 col-span-1 tool__card"
      [routerLink]="['/', i18nService.language, 'whatsapp-message-link-generator']">
      <div inlineSVG="our-tools/whatsapp.svg"></div>
      <span class="tool__name" translate="WhatsApp Message Link Generator"></span>
    </a>

    <a class="md:col-span-1 col-span-2 tool__card" [routerLink]="['/', i18nService.language, 'crop-photo']">
      <div inlineSVG="our-tools/gallery.svg"></div>
      <span class="tool__name" translate="Crop Photos"></span>
    </a>

    <a class="md:col-span-4 col-span-2 tool__card" [routerLink]="['/', i18nService.language, 'html-hosting']">
      <div inlineSVG="our-tools/html-hosting.svg"></div>
      <span class="tool__name" translate="HTML Hosting"></span>
    </a>
  </div>
</div>